import React, { useState, useEffect } from 'react'
import Logo from '../../../assets/Images/logo1.png'
import LoginImage from '../../../assets/Images/specx_logo.jpg'
import atoms from '../../../components/atoms'
import service from '../../../api/services'
import { useNavigate } from 'react-router'
import { useToasts } from 'react-toast-notifications';
import { BASE_URL } from '../../../constants/defaultValues'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'

const { Input, Button } = atoms
const Index = () => {
  const navigate = useNavigate()
  const { addToast } = useToasts();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isUsernameValid, setUsernameValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [showPassword, setShowPassword] = useState<boolean>(false)


  const passwordShowIconStyle = {
    // top: '66%',
    // right:'10%',
    // position:'relative',
    fontSize: "20px",
    left: "89%",
    bottom: "40px"
  }

  const handleUsernameChange = (e: any) => {
    setUsername(e.target.value);
    setUsernameValid(true);
  };

  const handlePasswordChange = (e: any) => {
    setPassword(e.target.value);
    setPasswordValid(true);
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Perform validation
    let isValid = true;

    if (username.trim() === '') {
      setUsernameValid(false);
      isValid = false;
    }

    if (password.trim() === '') {
      setPasswordValid(false);
      isValid = false;
    }
    if (isValid) {
      let payload = {
        "grant_type": "password",
        "username": username,
        "password": password,
        "scope": 1
      }
      const headers = {
        'Authorization': 'Basic YXBwbGljYXRpb246c2VjcmV0',
        "Content-Type": "application/x-www-form-urlencoded"
      };
      try {
        let response = await service.auth.login(payload, headers)
        if (response?.status === 200) {
          addToast(response?.data?.message, {
            appearance: 'success',
            autoDismiss: true,
            autoDismissTimeout: 3000,
          });
          localStorage.setItem("access_token", response?.data?.data?.accessToken)
          localStorage.setItem("user_email", response?.data?.data?.email)
          localStorage.setItem("username", response?.data?.data?.username)
          localStorage.setItem("role", response?.data?.data?.role || '')
          localStorage.setItem("refresh_token", response.data.data.refreshToken)
          navigate("/dashboard")
        }else{
          addToast("Invalid Credentials", {
            appearance: 'error',
            autoDismiss: true,
            autoDismissTimeout: 3000,
          });
        }
      } catch (error: any) {
        console.error(error)
        addToast(error?.response?.data?.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
      }

    }
  };

  useEffect(() => {
    const AUTH_TOKEN = localStorage.getItem("access_token")

    if (AUTH_TOKEN) {
      const previousUrl = document.referrer;
      if (previousUrl.startsWith(BASE_URL || "")) {
        navigate(-1);
      } else {
        navigate('/');
      }
    }
  }, [navigate]);

  return (
    <div className='p-5 d-flex justify-content-center align-items-center' style={{ background: '#D0F6FF30', height: '100vh' }} >
      <div className='card w-75 mx-auto border-0' style={{ borderRadius: '21px' }}>
        <div className='card-body dashboard-card-height p-4' >
          <div className='row'>
            <div className='col-md-6 col-12 align-items-center d-flex' style={{ borderRight: '1px solid #00000050' }}>
              <div className="p-3">
                <img src={LoginImage} alt="login form" className='w-100' />
              </div>
            </div>
            <div className='col-md-6 col-12 d-flex justify-content-center'>
              <div className="col-md-6 col-lg-10 d-flex align-items-center">
                <div className="card-body text-black">
                  <form onSubmit={handleSubmit}>
                    {/* <div className="mb-4">
                      <img src={Logo} className="fa-2x me-3 w-75" alt='' />
                    </div> */}
                    <div className="d-flex align-items-center mb-3 pb-1">
                      <span className="h1 fw-600 mb-0">Specxweb Admin</span>
                      {/* <span className="h1 fw-bold mb-0">Login</span> */}
                    </div>
                    {/* <h5 className="fw-normal mb-3 fw-600" style={{ letterSpacing: "1px", textDecoration: 'underline' }}>Login</h5> */}
                    <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: "1px", textDecoration: 'underline' }}>Sign into your account</h5>

                    <div className="form-outline mb-4">
                      <Input type={"text"} className={!isUsernameValid ? 'error' : ''}
                        onChange={handleUsernameChange} label={"Username"} defaultValue={username} placeholder={'Enter Username'} />
                      {!isUsernameValid && <p className="error-text">Username is required</p>}
                    </div>

                    <div className="form-outline mb-4">
                      <Input type={showPassword ? 'text' : "password"} onChange={handlePasswordChange}
                        className={!isPasswordValid ? 'error' : ''} label={"Password"} defaultValue={password} placeholder={'Enter Password'} />
                      {!isPasswordValid && <p className="error-text">Password is required</p>}
                      {<span
                        className='position-relative cursor-pointer'
                        style={passwordShowIconStyle}
                        onClick={() => setShowPassword(!showPassword)}>{showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                      </span>}
                    </div>

                    <div className="pt-1 mb-4 text-center">
                      <Button className={"btn btn-dark w-100 btn-block w-50"} type={"submit"}>Login</Button>
                    </div>
                    {/* <div>
                        <a className="small text-muted" href="#!">Forgot password?</a>
                      </div> */}
                    {/* <p className="mb-5 pb-lg-2" style={{ color: "#393f81" }}></p> */}
                    {/* <div className='d-flex justify-content-between'>
                      <a href="#!" className="small text-muted">Terms of use</a>
                      <a href="#!" className="small text-muted">Privacy policy</a>
                    </div> */}
                  </form>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Index